export var VALID_RANGE;
(function (VALID_RANGE) {
    VALID_RANGE[VALID_RANGE["LAT_MIN"] = -90] = "LAT_MIN";
    VALID_RANGE[VALID_RANGE["LAT_MAX"] = 90] = "LAT_MAX";
    VALID_RANGE[VALID_RANGE["LONG_MIN"] = -180] = "LONG_MIN";
    VALID_RANGE[VALID_RANGE["LONG_MAX"] = 180] = "LONG_MAX";
})(VALID_RANGE || (VALID_RANGE = {}));
export var FORMAT;
(function (FORMAT) {
    FORMAT["DMS"] = "DMS";
    FORMAT["DEC"] = "DEC";
    FORMAT["DDM"] = "DDM";
})(FORMAT || (FORMAT = {}));
export const FORMAT_INPUT = /([^NnEeSsWw\s'\u00B0])\d+(\.\d+)*/g;
export const MATCH_BEHIND_DECIMAL = /[^\.]\d+(\.\d+)*/g;
export var TYPE;
(function (TYPE) {
    TYPE["LAT"] = "LAT";
    TYPE["LONG"] = "LONG";
})(TYPE || (TYPE = {}));
export var WGS84;
(function (WGS84) {
    WGS84[WGS84["a"] = 6378137] = "a";
    WGS84[WGS84["b"] = 6356752.314245] = "b";
    WGS84[WGS84["f"] = 0.003352810664775663] = "f";
    WGS84[WGS84["feSq"] = 0.006694379990197492] = "feSq";
    WGS84[WGS84["seSq"] = 0.0067394967423333695] = "seSq";
})(WGS84 || (WGS84 = {}));
export var DISTANCE_FORMAT;
(function (DISTANCE_FORMAT) {
    DISTANCE_FORMAT[DISTANCE_FORMAT["KM"] = 1] = "KM";
    DISTANCE_FORMAT[DISTANCE_FORMAT["M"] = 1000] = "M";
    DISTANCE_FORMAT[DISTANCE_FORMAT["NM"] = 0.5399568] = "NM";
    DISTANCE_FORMAT[DISTANCE_FORMAT["MI"] = 0.62137119] = "MI";
})(DISTANCE_FORMAT || (DISTANCE_FORMAT = {}));
//# sourceMappingURL=constants.js.map